module.exports = __webpack_public_path__ + "static/media/skiing.c786d232.svg";